import { render, staticRenderFns } from "./xtPt.vue?vue&type=template&id=860e3856&scoped=true&"
import script from "./xtPt.vue?vue&type=script&lang=js&"
export * from "./xtPt.vue?vue&type=script&lang=js&"
import style0 from "./xtPt.vue?vue&type=style&index=0&id=860e3856&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "860e3856",
  null
  
)

export default component.exports